<template>
  <v-container>
    <v-tabs
      background-color="blue-grey lighten-3"
      fixed-tabs
      v-model="tab"
      color="black"
    >
      <v-tab ripple href="#tab-input" @change="setLoadRiwayatOff">Input</v-tab>
      <v-tab ripple href="#tab-history" @change="setLoadRiwayatOn"
        >Riwayat</v-tab
      >

      <v-tab-item value="tab-input">
        <RegisterHfInput
          :register="register"
          :load="loadRecord"
          :penampilanKlinisKategori="penampilanKlinisKategori"
          :statusGiziCategory="statusGiziCategory"
          :optimalisasiDosisCategory="optimalisasiDosisCategory"
          :ekokardiografiKategori="ekokardiografiKategori"
          :ecgKategori="ecgKategori"
          :followUpCategory="followUpCategory"
          :nyhaClassCategory="nyhaClassCategory"
          :laboratoriumCategory="laboratoriumCategory"
          :qolCategory="qolCategory"
          :cathCategory="cathCategory"
          :fungsiGinjalCategory="fungsiGinjalCategory"
          :ranapOutcomeCategory="ranapOutcomeCategory"
        ></RegisterHfInput>
      </v-tab-item>
      <v-tab-item value="tab-history">
        <RegisterHfHistory
          :loadRiwayat="loadRiwayat"
          :penampilanKlinisKategori="penampilanKlinisKategori"
          :statusGiziCategory="statusGiziCategory"
          :optimalisasiDosisCategory="optimalisasiDosisCategory"
          :ekokardiografiKategori="ekokardiografiKategori"
          :ecgKategori="ecgKategori"
          :laboratoriumCategory="laboratoriumCategory"
          :qolCategory="qolCategory"
          :cathCategory="cathCategory"
          :fungsiGinjalCategory="fungsiGinjalCategory"
          :ranapOutcomeCategory="ranapOutcomeCategory"
        ></RegisterHfHistory>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { storePasien } from "@/store/modules/pasien";

import RegisterHfHistory from "../reg_hf/RegisterHfHistory.vue";
import RegisterHfInput from "./RegisterHfInput.vue";

export default {
  name: "RegisterHf",
  components: {
    RegisterHfHistory,
    RegisterHfInput
  },
  props: {
    loadRecord: {
      require: false,
      type: Boolean,
      default: false
    },
    register: {
      type: String || Number
    }
    // rm: {
    //   type: String || Number,
    // },
  },
  mounted() {
    // console.log("reg hf mounted!");
    // this.getByRegister();
    this.loadRiwayat = false;
  },
  data() {
    return {
      rm: storePasien.identitasPasien.rm,
      penampilanKlinisKategori: [
        {
          index: "klin_tensi",
          name: "Tekanan Darah",
          type: "string"
        },
        {
          index: "klin_nadi",
          name: "Denyut Nadi",
          type: "string"
        },
        {
          index: "klin_riw_hf",
          name: "Riwayat HF",
          type: "boolean"
        },
        {
          index: "klin_riw_pci",
          name: "Riwayat PCI/CABG",
          type: "boolean"
        },
        {
          index: "klin_riw_op_katup",
          name: "Riwayat Operasi Katup",
          type: "boolean"
        },
        {
          index: "klin_hipo_perifer",
          name: "Hipoperfusi Perifer",
          type: "boolean"
        },
        {
          index: "klin_edema_perifer",
          name: "Edema Perifer",
          type: "boolean"
        },
        {
          index: "klin_old_mi",
          name: "Old MI/CAD",
          type: "boolean"
        },
        {
          index: "klin_anoreksia",
          name: "Anoreksia",
          type: "boolean"
        },
        {
          index: "klin_diabetes",
          name: "Diabetes",
          type: "boolean"
        },
        {
          index: "klin_hipertensi",
          name: "Hipertensi",
          type: "boolean"
        },
        {
          index: "klin_smoker",
          name: "Smoker",
          type: "boolean"
        },
        {
          index: "klin_ckd",
          name: "CKD",
          type: "boolean"
        },
        {
          index: "klin_kemo",
          name: "Kemoterapi",
          type: "boolean"
        },
        {
          index: "klin_nyha_class",
          name: "NYHA Class",
          type: "option"
        }
      ],
      ekokardiografiKategori: [
        {
          index: "eko_ef",
          name: "EF",
          type: "string"
        },
        {
          index: "eko_tapse",
          name: "TAPSE",
          type: "string"
        },
        {
          index: "eko_mr",
          name: "MR sedang-berat",
          type: "boolean"
        },
        {
          index: "eko_as",
          name: "AS sedang-berat",
          type: "boolean"
        },
        {
          index: "eko_ph",
          name: "PH",
          type: "boolean"
        }
      ],
      ecgKategori: [
        {
          name: "Sinus",
          index: "ecg_sinus",
          type: "boolean"
        },
        {
          name: "AF",
          index: "ecg_af",
          type: "boolean"
        },
        {
          name: "Bundle branch block",
          index: "ecg_bbb",
          type: "boolean"
        }
      ],
      followUpCategory: [
        {
          index: 1,
          name: "Rawat Ulang"
        },
        {
          index: 2,
          name: "Meninggal"
        }
      ],
      nyhaClassCategory: [
        {
          value: 1,
          name: "Class I"
        },
        {
          value: 2,
          name: "Class II"
        },
        {
          value: 3,
          name: "Class III"
        },
        {
          value: 4,
          name: "Class IV"
        }
      ],
      statusGiziCategory: [
        {
          index: "gizi_bb",
          name: "BB Terakhir"
        },
        {
          index: "gizi_tb",
          name: "TB"
        },
        {
          index: "gizi_albumin",
          name: "Albumin"
        },
        {
          index: "gizi_bsa",
          name: "BSA"
        },
        {
          index: "gizi_bmi",
          name: "BMI"
        }
      ],
      optimalisasiDosisCategory: [
        {
          index: "od_acei",
          name: "ACE-I/ARB/ARNI"
        },
        {
          index: "od_betablocker",
          name: "Betablocker"
        },
        {
          index: "od_mra",
          name: "MRA"
        }
      ],
      qolCategory: [
        {
          index: "qol1",
          label: "Kemampuan berjalan/ bergerak",
          value: null,
          type: "option",
          unit: null
        },
        {
          index: "qol2",
          label: "Perawatan Diri",
          value: null,
          type: "option",
          unit: null
        },
        {
          index: "qol3",
          label: "Kegiatan yang biasa dilakukan",
          value: null,
          type: "option",
          unit: null
        },
        {
          index: "qol4",
          label: "Rasa kesakitan/ tidak nyaman",
          value: null,
          type: "option",
          unit: null
        },
        {
          index: "qol5",
          label: "Rasa cemas/ depresi",
          value: null,
          type: "option",
          unit: null
        }
      ],
      laboratoriumCategory: [
        {
          index: "hb",
          label: "Hb",
          value: null,
          type: "number",
          unit: "g/dl"
        },
        {
          index: "hmt",
          label: "Hmt",
          value: null,
          type: "number",
          unit: "%"
        },
        {
          index: "leukosit",
          label: "Leukosit",
          value: null,
          type: "number",
          unit: "/ul"
        },
        {
          index: "asam_urat",
          label: "Asam Urat",
          value: null,
          type: "number",
          unit: "mg/dl"
        },
        {
          index: "gds",
          label: "GD Sewaktu",
          value: null,
          type: "number",
          unit: "g/dl"
        },
        {
          index: "gdp",
          label: "GD Puasa",
          value: null,
          type: "number",
          unit: "g/dl"
        },
        {
          index: "gd2jpp",
          label: "GD2jpp",
          value: null,
          type: "number",
          unit: "g/dl"
        },
        {
          index: "na",
          label: "Na",
          value: null,
          type: "number",
          unit: "mmol/l"
        },
        {
          index: "k",
          label: "K",
          value: null,
          type: "number",
          unit: "mmol/l"
        }
      ],
      cathCategory: [
        {
          index: "cad",
          label: "CAD",
          type: "boolean",
          value: null,
          unit: null
        }
      ],
      fungsiGinjalCategory: [
        {
          index: "ureum",
          label: "Ureum",
          type: "number",
          value: null,
          unit: "mg/dl"
        },
        {
          index: "bun",
          label: "BUN",
          type: "number",
          value: null,
          unit: null
        },
        {
          index: "creatinin",
          label: "Creatinin",
          type: "number",
          value: null,
          unit: "mg/dl"
        },
        {
          index: "gfr_mdrd",
          label: "GFR (MDRD)",
          type: "number",
          value: null,
          unit: "mL/min/1.73m2"
        }
      ],
      ranapOutcomeCategory: [
        {
          index: "date_in",
          label: "Tanggal Masuk",
          type: "date",
          value: null,
          unit: null
        },
        {
          index: "date_out",
          label: "Tanggal Keluar",
          type: "date",
          value: null,
          unit: null
        },
        {
          index: "lama_rawat",
          label: "Lama Rawat",
          type: "number",
          value: null,
          unit: "hari"
        },
        {
          index: "is_meninggal",
          label: "Meninggal",
          type: "boolean",
          value: false,
          unit: null
        }
      ],
      loadRiwayat: null
    };
  },

  methods: {
    setLoadRiwayatOn() {
      this.$nextTick(() => {
        this.loadRiwayat = true;
      });
    },
    setLoadRiwayatOff() {
      this.$nextTick(() => {
        this.loadRiwayat = false;
      });
    }
  }
};
</script>
